// const breathingKeyframes = keyframes({
//   '0%': { opacity: 1 },
//   '50%': { opacity: 0.4 }, // Adjust the opacity level as needed
//   '100%': { opacity: 1 }
// });
export const ChatStyles = {
    search: {
        width: '100%',
        // borderRadius: tokens.borderRadiusMedium,
        backgroundColor: 'white'
    },
    documentButton: {
        display: 'flex',
        justifyContent: 'center'
    },
    chathistoryButton: {
        display: 'flex',
        justifyContent: 'center'
    },
    typingdots: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '24px',
        '& > div': {
            width: '8px',
            height: '8px',
            margin: '0 2px',
            borderRadius: '50%',
            backgroundColor: '#52DECA',
            animation: 'dotFlashing 1s infinite linear alternate'
        },
        '& > div:nth-of-type(1)': {
            animationDelay: '0s'
        },
        '& > div:nth-of-type(2)': {
            animationDelay: '0.2s'
        },
        '& > div:nth-of-type(3)': {
            animationDelay: '0.4s'
        },
        '@keyframes dotFlashing': {
            '0%': {
                opacity: 1
            },
            '50%': {
                opacity: 0.5
            },
            '100%': {
                opacity: 0
            }
        }
    },
    breathingText: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginTop: '8px !important',
        // animationName: breathingKeyframes, // Reference the keyframes
        animationDuration: '1.5s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite'
    }
};
